import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../../hooks/useVerifiedPermissions.ts";
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {ImportRecordButton} from '../buttons/ImportRecordButton.tsx';
import {ImportAllRecordsButton} from '../buttons/ImportAllRecordsButton.tsx';
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import config from "../config";
import {rbacActions} from "../../../../config/rbac/actions.ts";


const useTools = () => {

    const {allowedActions} = useVerifiedPermissions()

    const tools = [<ReloadRecordsButton key='reload'/>];

    if (allowedActions.includes(rbacActions.ImportCodePipeline)) {
        tools.push(<ImportRecordButton key='import'/>);
    }

    if (allowedActions.includes(rbacActions.ImportAllCodePipelines)) {
        tools.push(<ImportAllRecordsButton key='import-all'/>);
    }

    if (allowedActions.includes(rbacActions.DeleteCodePipeline)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    return tools;
};

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get(config.titles.plural)}
            tools={useTools()}
        />
    );
};
